import React, { useState, useEffect, useRef } from "react";
import { TextField, Box, Typography, Avatar, Grid } from "@mui/material";
import Logo from "../../image/boozLogo.png";
import CommonDialog from "../notification/ErrorDialogbox";
import { useDispatch, useSelector } from "react-redux";
import {
  verifyMobileOtpRequest,
  requestMobileOtpRequest,
} from "../../redux/auth/AuthAction";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import CustomButton from "../constant/commonButton";
import CryptoJS from "crypto-js";
import { APP_LINK } from "../global/MenuItems";

const MobileOTPVerify = () => {
  if (window.firebase) {
    console.warn('Firebase is loaded but not needed for OTP verification');
    window.firebase.initializeApp = () => {
      console.warn('Firebase initialization prevented in OTP component');
      return { auth: () => ({ currentUser: null }) };
    };
  }
  const { handleSubmit, setValue } = useForm();
  const [mobileOtp, setMobileOtp] = useState(["", "", "", "", "", ""]);
  const [countdown, setCountdown] = useState(45);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [otpError, setOtpError] = useState("");
  const [loading, setLoading] = useState(false);
  const [decryptedPhone, setDecryptedPhone] = useState("");

  const mobileOtpRequested = useRef(false);
  const firstInputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const verifyMobileOtpDetails =
    useSelector((state) => state?.auth?.registerMobileOtp) || {};
  console.log(
    "verifyMobileOtpDetails?.success:",
    verifyMobileOtpDetails?.success
  );

  const SECRET_KEY = "843567893696976453275974432697R634976";

  const decryptData = (encryptedData) => {
    if (!encryptedData) return "";
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedText) {
        console.error("Decryption returned empty string.");
      }

      return decryptedText;
    } catch (error) {
      console.error("Decryption failed:", error);
      return "";
    }
  };

  useEffect(() => {
    if (!mobileOtpRequested.current) {
      const encryptedPhone = localStorage.getItem("phone");
      if (encryptedPhone) {
        const phone = decryptData(encryptedPhone);
        setDecryptedPhone(phone);
        const formData = { phone: phone, subject_type: "1" };
        dispatch(requestMobileOtpRequest(formData));
        mobileOtpRequested.current = true;
      }
    }
  }, [dispatch]);

  useEffect(() => {
    let timer;
    if (isResendDisabled && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    if (countdown === 0) {
      setIsResendDisabled(false);
    }
    return () => clearInterval(timer);
  }, [isResendDisabled, countdown]);

  useEffect(() => {
    if (firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, []);

  const handleChange = (e, index) => {
    const value = e?.target?.value;
    if (/^[0-9]*$/.test(value) && value?.length <= 1) {
      const newOtp = [...mobileOtp];
      newOtp[index] = value;
      setMobileOtp(newOtp);
      setValue(`phone_verification_code[${index}]`, value);
      if (value && index < mobileOtp?.length - 1) {
        document.getElementById(`mobile-otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e?.key === "Backspace" && !mobileOtp[index] && index > 0) {
      document.getElementById(`mobile-otp-input-${index - 1}`).focus();
    }
  };

  const onSubmit = async (data) => {
    const encryptedPhone = localStorage.getItem("phone");
    const phone = decryptData(encryptedPhone);

    if (!phone) {
      console.error("Decryption failed or phone is missing.");
      return;
    }

    if (
      mobileOtp.some((digit) => digit === "") ||
      mobileOtp.join("").length < 6
    ) {
      setOtpError("Mobile OTP required");
      setTimeout(() => {
        setOtpError("");
      }, 3000);
      return;
    }

    const mobileOtpCode = mobileOtp.join("");
    const mobileOtpData = {
      phone: phone,
      phone_verification_code: mobileOtpCode,
    };

    setLoading(true);
    await dispatch(verifyMobileOtpRequest(mobileOtpData));
    setLoading(false);
  };

  useEffect(() => {
    if (verifyMobileOtpDetails?.success) {
      console.log(
        "verifyMobileOtpDetails:",
        verifyMobileOtpDetails,
        verifyMobileOtpDetails?.success
      );
      setDialogMessage("Account activated successfully");
      setIsSuccess(true);
      setDialogOpen(true);
    }

    if (verifyMobileOtpDetails?.error) {
      setDialogMessage("Enter the correct Mobile OTP");
      setIsSuccess(false);
      setDialogOpen(true);
    }
  }, [verifyMobileOtpDetails]);

  const handleDialogClose = () => {
    setDialogOpen(false);
    if (verifyMobileOtpDetails?.success) {
      localStorage.removeItem("email");
      localStorage.removeItem("phone");
      navigate(APP_LINK.LOGIN);
    }
  };

  const handleResendOtp = () => {
    setIsResendDisabled(true);

    const encryptedPhone = localStorage.getItem("phone");
    const phone = decryptData(encryptedPhone);
    const formData = { phone: phone, subject_type: "1" };

    setMobileOtp(["", "", "", "", "", ""]);
    setOtpError("");
    setDialogMessage("");
    setDialogOpen(false);

    dispatch(requestMobileOtpRequest(formData));
    setCountdown(45);
  };

  const handleBackToLogin = () => {
    navigate("/");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Box
        elevation={3}
        sx={{ padding: 2, textAlign: "center", width: 500, height: 400 }}
      >
        <Grid item xs={12} align="center">
          <Avatar src={Logo} className="avatar" />
        </Grid>
        <Typography variant="h6">Enter Mobile OTP</Typography>
        {decryptedPhone && (
          <Typography
            variant="body2"
            sx={{
              marginBottom: 2,
              color: "#1976d2",
              fontWeight: 500,
            }}
          >
            Mobile OTP has been sent to{" "}
            <span style={{ fontWeight: "bold", color: "#d32f2f" }}>
              {decryptedPhone}
            </span>
          </Typography>
        )}

        <Box
          sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}
        >
          {mobileOtp?.map((digit, index) => (
            <TextField
              key={index}
              inputRef={index === 0 ? firstInputRef : null}
              id={`mobile-otp-input-${index}`}
              name={`phone_verification_code[${index}]`}
              value={digit}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              inputProps={{ maxLength: 1 }}
              sx={{
                width: "50px",
                height: "50px",
                textAlign: "center",
                margin: "0 5px",
              }}
            />
          ))}
        </Box>
        {otpError && (
          <Typography variant="body2" color="error">
            {otpError}
          </Typography>
        )}
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            width: "100%",
            paddingTop: "10px",
            paddingLeft: "40px",
            paddingRight: "40px",
            justifyContent: "center",
          }}
        >
          <CustomButton
            text="Submit"
            size="large"
            type="submit"
            buttonStyle="SubmitButton1"
            variant="contained"
            onClick={handleSubmit(onSubmit)}
            disabled={loading || verifyMobileOtpDetails?.inProgress}
            loading={loading || verifyMobileOtpDetails?.inProgress}
          />
          <CustomButton
            variant="outlined"
            onClick={handleResendOtp}
            buttonStyle="style1"
            disabled={isResendDisabled}
            sx={{
              color: isResendDisabled ? "red" : "inherit",
            }}
          >
            {isResendDisabled ? `Resend OTP in ${countdown}s` : "Resend OTP"}
          </CustomButton>
        </Box>
        <Box>
          <CustomButton
            variant="text"
            onClick={handleBackToLogin}
            sx={{ textDecoration: "none", color: "inherit" }}
          >
            Back to Login
          </CustomButton>
        </Box>

        {/* Dialog */}
        <CommonDialog
          open={dialogOpen}
          isSuccess={isSuccess}
          onClose={handleDialogClose}
          messageSuccess={dialogMessage}
          messageError={dialogMessage}
        />
      </Box>
    </Box>
  );
};

export default MobileOTPVerify;
